import React from 'react';
export function AnnouncementBar() {
  const messages = ['📩 Acceso inmediato por email', '🧶 Guía paso a paso — apta para principiantes', '💖 Precio especial de lanzamiento', '⏳ Empezá a tejer hoy mismo'];
  const repeatedMessages = [...messages, ...messages, ...messages, ...messages];
  return <div className="w-full bg-pink-dark text-white overflow-hidden" role="marquee" aria-label="Anuncios" data-id="element-28">
      <div className="animate-marquee flex whitespace-nowrap py-2.5" data-id="element-29">
        {repeatedMessages.map((msg, i) => <span key={i} className="text-sm font-body mx-8 inline-block" data-id="element-30">
            {msg}
          </span>)}
      </div>
    </div>;
}